// Barrel that re-exports ticket-related types from the auto-generated GraphQL
// types, giving ticket consumers one stable import path. Everything here is the
// generated source of truth that aligns with the backend schema — do NOT
// hand-define shapes here; fix the schema and re-run codegen instead.
export type {
  Ticket,
  TicketCategory,
  TicketMessage,
  TicketAttachment,
  TicketPaginator,
  ReplyTicketInput,
  InputMaybe,
  Scalars,
} from './composition-functions';

import { TicketStatus, TicketPriority } from './composition-functions';

export { TicketStatus, TicketPriority };

// Canonical picker orderings. Object.values(enum) renders the generated
// enums' alphabetical member order (Closed first, High before Low), so
// pickers share these hand-ordered lists instead of each rolling their own.
export const TICKET_STATUS_ORDER: TicketStatus[] = [
  TicketStatus.Open,
  TicketStatus.InProgress,
  TicketStatus.Resolved,
  TicketStatus.Closed,
];

export const TICKET_PRIORITY_ORDER: TicketPriority[] = [
  TicketPriority.Low,
  TicketPriority.Medium,
  TicketPriority.High,
  TicketPriority.Urgent,
];
